import React, { useEffect } from 'react';
import { Modal, Icon, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAdministrativeRepresentative, fetchAdministrativeRepresentativeFilter, administrativeRepresentativeClear, administrativeRepresentativeFilterClear } from 'app/actions/AdministrativeRepresentativeActions';
import { getAdministrativeRepresentative, getAdministrativeRepresentativeFilter, getIsLoadingAdministrativeRepresentative } from 'app/reducers';
import IconButton from '@material-ui/core/IconButton';
import ApiService from 'app/services/ApiService';
import { setTimeout } from 'timers';
import isEmpty from 'app/utils/IsEmpty';

export default function AdministrativeRepresentativeTableContainer(props) {
    const { classes } = props;
    const { confirm } = Modal;

    const { siteId } = useSelector(state => state.Auth);

    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'responsibleName',
            key: 'responsibleName',
            sorter: true,
            width: 300,
            ellipsis: true

        },
        {

        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'idResponsible',
            fixed: 'right',
            width: 120,
            render: (text, record) => (
                <div className={classes.buttons}>
                    {
                        siteId === 'HUB' ?
                            <Tooltip placement="bottomLeft" title={'Eliminar'}>
                                <IconButton className={classes.deleteIcon} onClick={() => showConfirmDelete(record)}>
                                    <Icon type="delete" />
                                </IconButton>
                            </Tooltip>
                            : null
                    }

                    <Tooltip placement="bottomLeft" title={siteId === 'HUB' ? 'Editar' : 'Visualizar'}>
                        <IconButton className={classes.editIcon} onClick={() => showEdit(record)}>
                            {
                                siteId === 'HUB' ?
                                    <Icon type="edit" />
                                    :
                                    <Icon type="eye" />
                            }
                        </IconButton>
                    </Tooltip>

                </div>
            )
        }
    ];

    const showEdit = (param) => {
        props.isVisibleForm(true);
        props.setIdResponsible(param.idResponsible);
        props.setNameResponsible(param.responsibleName);
    }

    const showConfirmDelete = (param) => {
        confirm({
            title: '¿Eliminar Representante Administrativo?',
            content: param.responsibleName,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                props.setFiltroResponsible(props.FiltroResponsible.filter(x => x !== param.responsibleName));
                return deleteResponsible(param);
            },
            onCancel() { },
        });

    }

    async function deleteResponsible(param) {
        await ApiService.deleteResponsible(param.idResponsible).then(res => {
            dispatch(administrativeRepresentativeFilterClear());
            dispatch(administrativeRepresentativeClear());
            dispatch(fetchAdministrativeRepresentativeFilter({ idRol: 2 }));
            dispatch(fetchAdministrativeRepresentative({
                responsibleName: props.FiltroResponsible.filter(x => x !== param.responsibleName).join(','),
                idRol: 2,
                sortColumn: column,
                sortDir: order, offset: offset, limit: limit
            }));
            const modal = Modal.success({
                title: `Eliminado Correctamente`,
                content: '',
            });

            setTimeout(function () {
                modal.destroy();
            }, 3000)

        });
    }

    let administrativeRepresentative = useSelector(getAdministrativeRepresentative);
    let administrativeRepresentativeFilter = useSelector(getAdministrativeRepresentativeFilter);

    let isLoading = useSelector(getIsLoadingAdministrativeRepresentative);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(administrativeRepresentative)) fetchAdministrativeRepresentativeAction();
        if (isEmpty(administrativeRepresentativeFilter)) fetchAdministrativeRepresentativeFilterAction();
    }, []);

    const handleTableChange = (pagination, filters, sorter) => {

        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }

        dispatch(fetchAdministrativeRepresentative(
            {
                responsibleName: props.FiltroResponsible.join('|'),
                //responsibleName: (typeof props.formData.responsibleName === "undefined") ? '' : props.formData.responsibleName,
                idRol: 2,
                sortColumn: column,
                sortDir: order,
                offset: ((pagination.current - 1) * pagination.pageSize),
                limit: pagination.pageSize
            }));
    };

    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && administrativeRepresentative.length > 0) {
            pagination.total = administrativeRepresentative[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter != null) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }



    const fetchAdministrativeRepresentativeAction = () => dispatch(fetchAdministrativeRepresentative({
        responsibleName: props.FiltroResponsible !== undefined ? props.FiltroResponsible.join(',') : '',
        idRol: 2,
        sortColumn: column,
        sortDir: order, offset: offset, limit: limit
    }));
    const fetchAdministrativeRepresentativeFilterAction = () => dispatch(fetchAdministrativeRepresentativeFilter({ idRol: 2 }))
    return (props.children({ pagination: pagination, cols: columns, administrativeRepresentative, administrativeRepresentativeFilter, isLoading, handleTableChange: handleTableChange }));
}

